import { Box, Typography } from '@mui/material';
import React from 'react';

interface CardProps {
  project: string;
  currentAllocation: string;
  colorCode: string;
}

const ProjectMemberAllocationCard = ({
  project,
  currentAllocation,
  colorCode
}: CardProps): JSX.Element => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '15px'
      }}
    >
      <Box>
        <Box sx={{ display: 'flex', gap: '15px' }}>
          <Box
            sx={{
              borderRadius: '50%',
              width: '22px',
              height: '22px',
              background: colorCode
            }}
          />
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 400,
              fontFamily: 'Be Vietnam Pro',
              color: '#1A1B1F',
              maxWidth: '100px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {project}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexDirection: 'row',
          marginRight: '210px'
        }}
      >
        <Box
          sx={{
            minWidth: '25px',
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            alignItems: 'left'
          }}
        >
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 400,
              fontFamily: 'Be Vietnam Pro',
              color: '#1A1B1F',
              textAlign: 'center'
            }}
          >
            {currentAllocation}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectMemberAllocationCard;
